<template>
  <article class="CartProduct">
    <div class="CartProduct__content">
      <img class="CartProduct__picture" :src="thumbURL" />
      <div>
        <div class="CartProduct__producer">
          {{ producer }}
        </div>
        <div class="CartProduct__name">
          {{ name }} {{ year }}<br />
          {{ additional_name }}
        </div>
        <div class="CartProduct__tags">
          <div class="Tag" v-if="offer && offer.products_number_free > 0">{{ offer.products_number }}+{{ offer.products_number_free }} {{ "gratuite" | pluralize(offer.products_number_free) }}</div>
        </div>
        <div v-if="!availability" class="CartProduct__availability">
          Ce produit n'est plus disponible
        </div>

      </div>
      <div class="CartProduct__footer" :class="{'is-disabled' : !availability}">
        <div class="CartProduct__quantity"> {{ priceFormat(price) }}€x{{ chargeableBtls }}</div>
        <Price :price="totalPrice" />
      </div>
    </div>
    <div class="CartProduct__edition">
      <a @click="$emit('remove')" class="CartProduct__remove">
        <IconBase iconName="trash"><IconTrash /></IconBase>
        Retirer
      </a>
      <template v-if="availability">
        <Quantity class="CartProduct__quantityEdition" v-model="internalQuantity" :step="orderStep" />
      </template>
    </div>
  </article>
</template>
<script>
import orderLineMixin from "../mixins/orderLineMixin";
import priceFormat from "../utils/priceFormat";
import chargeableBtls from "../utils/chargeableBtls";
import Quantity from "./Quantity";
import IconTrash from "./icons/IconTrash";

export default {
  name: "CartProduct",
  mixins: [orderLineMixin],
  props: {
    availability: {
      type: Boolean,
      default: true
    },
    offer: {
      validator: value => value === null || typeof value === "object",
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    internalQuantity: {
      get() {
        return this.quantity;
      },
      set(value) {
        this.$emit("update", value);
      }
    },
    totalPrice() {
      return this.price * this.chargeableBtls;
    },
    chargeableBtls() {
      return chargeableBtls(this.$props);
    }
  },
  methods: {
    priceFormat
  },
  components: {
    Quantity,
    IconTrash
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.CartProduct {
  margin-bottom: $global-margin/2;
  border: 1px solid $color-smoke-border;
  text-align: left;
  transition: all 0.2s ease-in-out;
  background-color: #fff;

  &__content {
    flex: 1 0 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $global-margin/3 $global-margin;
  }

  &__edition {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.75rem;
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 500;
    background-color: $color-smoke;
  }

  &__quantityEdition {
    border-left: 1px solid rgba($color-smoke, 0.3);
    font-size: 1rem;
    margin-left: $global-margin;
  }

  &__remove {
    cursor: pointer;
  }

  &__count,
  &__remove {
    padding: 0.5rem 0;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
  }

  &__footer {
    margin-left: auto;
    text-align: right;

    &.is-disabled {
      opacity: 0.3;
    }
  }

  &__producer {
    font-weight: 500;
    font-size: 0.5rem;
    margin-bottom: 0.2rem;
    text-transform: capitalize;
  }

  &__name {
    font-weight: 700;
    font-size: 0.75rem;
  }

  &__availability {
    color: red;
    margin-top: 0.2rem;
    font-weight: 700;
    font-size: 0.6rem;
  }

  &__picture {
    flex: 0 0 auto;
    max-height: 3.375rem;
    margin: -2px $global-margin -2px 0;
  }

  &__quantity {
    font-size: 0.75rem;
    font-family: $primary-font;
  }

  @media (min-width: 900px) {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
}
</style>
